<template>
<div class="localRemoteControlConfiguration">
  <el-card class="box-card" shadow="never">{{ projectName }}</el-card>
  <div class="partition">
    <span class="title">遥控</span>
    <span class="newBtn">
      <el-button type="primary" @click="addRemoteControlRow()">新建行</el-button>
    </span>
    <div class="content">
      <div class="remoteControl" v-for="(item, index) in remoteControlData" :key="index">
        <span class="element">
          <p style="fontSize: 14px;width: 150px;">{{item.title}}</p>
        </span>
        <span class="element">
          <div class="colorBlock" :style="{background: item.color}"></div>
        </span>
        <span class="element">
          <el-select v-model="item.status" @change="changeFieldList(item)" style="width: 200px;">
            <el-option v-for="(item1, index1) in item.remoteControlFieldList" :key="index1" :label="item1.name" :value="item1.value"></el-option>
          </el-select>
        </span>
        <span class="element">
          <el-button type="primary" @click="remoteControlConfig(index)">配置</el-button>
        </span>
        <span class="element">
          <i class="el-icon-circle-plus-outline" @click="addRemoteControlRow()"></i>
        </span>
        <span class="element">
          <i class="el-icon-remove-outline" @click="delRemoteControlRow(item, index)"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="partition">
    <span class="title">遥调</span>
    <span class="newBtn">
      <el-button type="primary" @click="addTeleControlRow()">新建行</el-button>
    </span>
    <div class="teleControl">
      <div v-for="(item, index) in teleControlData" :key="index">
        <el-form :inline="true" class="demo-form-inline">
          <span v-for="(item1, index1) in item.dataList" :key="index1">
            <el-form-item label="标题" style="margin-left: 25px;">
              <el-input v-model="item1.title" readonly style="width: 80px;"></el-input>
            </el-form-item>
            <el-form-item label="数据点">
              <el-input v-model="item1.tuningField" readonly style="width: 170px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="teleControlConfig(item1, item.row, index1)">配置</el-button>
            </el-form-item>
          </span>
          <span>
            <el-button type="danger" @click="delTeleControlRow(item, index)">删除行</el-button>
          </span>
        </el-form>
      </div>
    </div>
  </div>
  <!-- 遥控 -->
  <Dialog ref="remoteControlDialog" title="遥控配置" dlgWidth="40%" @closeDialog="closeRemoteControlDialog">
    <el-form class="remoteControlDialogForm" :model="remoteControlConfigData">
      <el-form-item class="bottom-line">
        <div class="element mb13">
          <span>标题</span>
          <el-input v-model="remoteControlConfigData.title" placeholder="标题" style="width: 200px;"></el-input>
        </div>
      </el-form-item>
      <el-form-item class="bottom-line">
        <div>只读点</div>
        <div class="formDiv">
          <span class="element colFlex">
            <span class="mr10">数据点</span>
            <el-input class="mr10" v-model="remoteControlConfigData.readField" readonly style="width: 300px;"></el-input>
            <el-button type="primary" @click="readOnlyDataPoint('readOnlyPoint')">选择</el-button>
          </span>
        </div>
        <div class="valueDiv" v-for="(item, index) in remoteControlConfigData.remoteControlFieldDTOList" :key="index">
          <span class="element">
            数值
          </span>
          <span class="element">
            <el-input v-model="item.value" style="width: 80px;"></el-input>
          </span>
          <span class="element">
            显示
          </span>
          <span class="element">
            <el-input v-model="item.name" style="width: 200px;"></el-input>
          </span>
          <span class="element">
            颜色
          </span>
          <span class="element">
            <el-color-picker v-model="item.color" :predefine="predefineColors"></el-color-picker>
          </span>
          <span class="element">
            <i class="el-icon-circle-plus-outline" @click="addReadOnlyPointRow"></i>
          </span>
          <span class="element">
            <i v-if="remoteControlConfigData.remoteControlFieldDTOList.length > 1" class="el-icon-remove-outline" @click="removeReadOnlyPointRow(item, index)"></i>
          </span>
        </div>
      </el-form-item>
      <el-form-item class="bottom-line">
        <div>下置点</div>
        <div class="valueDiv" v-for="(item, index) in remoteControlConfigData.remoteControlFieldDTOList" :key="index">
          <span style="margin-bottom: 10px;">
            关联
          </span>
          <span class="element">
            <el-input v-model="item.name" style="width: 120px;"></el-input>
          </span>
          <span class="element">
            目标值
          </span>
          <span class="element">
            <el-input v-model="item.targetValue" style="width: 80px;"></el-input>
          </span>
          <span class="element">
            数据点
          </span>
          <span class="element">
            <el-input v-model="item.issuedFields" readonly style="width: 250px;"></el-input>
          </span>
          <span class="element">
            <el-button type="primary" @click="readOnlyDataPoint('lowerPoint', index)">选择</el-button>
          </span>
        </div>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="cancelRemoteControlDataSave()">取消</el-button>
      <el-button type="primary" @click="remoteControlDataSave()">保存</el-button>
    </template>
  </Dialog>
  <!-- 遥调 -->
  <Dialog ref="teleControlDialog" title="遥调配置" @closeDialog="closeTeleControlDialog">
    <el-form class="teleControlDialogForm" :model="teleControlConfigData">
      <el-form-item class="bottom-line">
        <div class="element mb13">
          <span>标题</span>
          <el-input v-model="teleControlConfigData.title" placeholder="标题" style="width: 200px;"></el-input>
        </div>
      </el-form-item>
      <el-form-item class="bottom-line">
        <div>下置点</div>
        <div class="mb13">
          <span class="element">
            数据点
          </span>
          <span class="element">
            <el-input v-model="teleControlConfigData.tuningField" readonly style="width: 200px;"></el-input>
          </span>
          <span class="element">
            <el-button type="primary" @click="readOnlyDataPoint('teleControlPoint', index)">选择</el-button>
          </span>
        </div>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="cancelTeleControlDataSave()">取消</el-button>
      <el-button type="primary" @click="teleControlDataSave()">保存</el-button>
    </template>
  </Dialog>
  <!-- 数据点 -->
  <Dialog ref="dataPointDialog" title="数据点配置" dlgWidth="50%" @closeDialog="closeDataPointDialog">
    <DataPointConfiguration :isDialog="isDataPointDialog" :projectId="projectId" @currRowData="getCurrRowData($event)"></DataPointConfiguration>
    <template slot="footer">
      <el-button type="primary" @click="dataPointSubmit()">确定</el-button>
    </template>
  </Dialog>
</div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import Dialog from '@/components/dialog';
import DataPointConfiguration from '../../svolt/components/data-point-configuration.vue';
export default {
  props: {
    projectId: {
      type: [String, Number]
    },
    projectName: {
      type: [String, Number]
    }
  },
  data() {
    return {
      remoteControlData: [],
      remoteControlConfigData: {
        title: '',
        readField: '',
        remoteControlFieldDTOList: [{
          color: '',
          issuedFields: '',
          name: '',
          sn: '',
          targetValue: '',
          value: ''
        }]
      },
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585'
      ],
      type: '',
      index: '',
      teleControlData: [],
      teleControlConfigData: {
        title: '',
        tuningField: ''
      },
      isDataPointDialog: false
    };
  },
  components: {
    Dialog,
    DataPointConfiguration
  },
  mounted() {
    this.searchRemoteControlList();
    this.searchRemoteTuningList();
  },
  methods: {
    closeRemoteControlDialog() {
      this.$refs.remoteControlDialog.close();
      this.isDataPointDialog = false;
    },
    closeTeleControlDialog() {
      this.$refs.teleControlDialog.close();
      this.isDataPointDialog = false;
    },
    closeDataPointDialog() {
      this.$refs.dataPointDialog.close();
      this.isDataPointDialog = false;
    },
    //查询遥控列表
    searchRemoteControlList() {
      let params = {
        projectId: this.projectId
      };
      PROJECTAPI.searchRemoteControlList(params).then(res => {
        if (res.data.code == 200) {
          this.remoteControlData = res.data.data;
          for (let i in this.remoteControlData) {
            this.remoteControlData[i].status = this.remoteControlData[i].remoteControlFieldList[0].value;
            this.remoteControlData[i].color = this.remoteControlData[i].remoteControlFieldList[0].color;
          }
        }
      });
    },
    changeFieldList(item) {
      this.$forceUpdate();
      let options = item.remoteControlFieldList;
      for (let i in options) {
        if (item.status == options[i].value) {
          item.color = options[i].color;
        }
      }
    },
    //添加遥控配置
    addRemoteControlRow() {
      this.remoteControlData.push({
        title: '',
        show: '',
        status: '',
        option: []
      })
    },
    //配置遥控参数
    remoteControlConfig(index) {
      this.$refs.remoteControlDialog.open();
      if (this.remoteControlData[index].remoteControlId) {
        this.remoteControlConfigData.projectId = this.remoteControlData[index].projectId;
        this.remoteControlConfigData.readField = this.remoteControlData[index].readField;
        this.remoteControlConfigData.remoteControlSn = this.remoteControlData[index].remoteControlSn;
        this.remoteControlConfigData.remoteControlId = this.remoteControlData[index].remoteControlId;
        this.remoteControlConfigData.title = this.remoteControlData[index].title;
        this.remoteControlConfigData.remoteControlFieldDTOList = this.remoteControlData[index].remoteControlFieldList;
      } else {
        this.remoteControlConfigData = {
          title: '',
          readField: '',
          remoteControlFieldDTOList: [{
            color: '',
            issuedFields: '',
            name: '',
            sn: '',
            targetValue: '',
            value: ''
          }]
        }
      }
    },
    //选择数据点
    readOnlyDataPoint(type, index) {
      this.type = type;
      this.index = index;
      this.$refs.dataPointDialog.open();
      this.isDataPointDialog = true;
    },
    getCurrRowData(row) {
      if (this.type == "readOnlyPoint") {
        this.remoteControlConfigData.readField = row.field;
        this.remoteControlConfigData.remoteControlSn = row.sn;
      } else if (this.type == "lowerPoint") {
        this.remoteControlConfigData.remoteControlFieldDTOList[this.index]["issuedFields"] = row.field;
        this.remoteControlConfigData.remoteControlFieldDTOList[this.index]["sn"] = row.sn;
      } else if (this.type == "teleControlPoint") {
        this.teleControlConfigData.tuningField = row.field;
        this.teleControlConfigData.sn = row.sn;
      }
    },
    dataPointSubmit() {
      this.$refs.dataPointDialog.close();
      this.isDataPointDialog = false;
    },
    //添加数据点行
    addReadOnlyPointRow() {
      this.remoteControlConfigData.remoteControlFieldDTOList.push({
        color: '',
        issuedFields: '',
        name: '',
        sn: '',
        targetValue: '',
        value: ''
      })
    },
    //删除数据点行
    removeReadOnlyPointRow(item, index) {
      if (item.id) {
        let self = this;
        this.$confirm('此行已配置数据，确定删除？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.deleteRemoteControlField(item.id, index);
          })
          .catch(() => {});
      } else {
        this.remoteControlConfigData.remoteControlFieldDTOList.splice(index, 1);
      }
    },
    deleteRemoteControlField(remoteControlFieldId, index) {
      let params = {
        remoteControlFieldId: remoteControlFieldId
      };
      PROJECTAPI.deleteRemoteControlField(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.remoteControlConfigData.remoteControlFieldDTOList.splice(index, 1);
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    //遥控配置保存
    remoteControlDataSave() {
      if (this.remoteControlConfigData.title.length <= 20) {
        let params = this.remoteControlConfigData;
        params.projectId = this.projectId;
        PROJECTAPI.addRemoteControl(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("保存成功！");
            this.$refs.remoteControlDialog.close();
            this.isDataPointDialog = false;
            this.searchRemoteControlList();
          } else {
            this.$message.warning(res.data.msg);
          }
        });
      } else {
        this.$message.warning("标题输入的字数过多，请重新输入！");
      }
    },
    cancelRemoteControlDataSave() {
      this.$refs.remoteControlDialog.close();
      this.isDataPointDialog = false;
    },
    //删除遥控配置
    delRemoteControlRow(item, index) {
      if (item.remoteControlId) {
        let self = this;
        this.$confirm('此行已配置数据，确定删除？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.deleteRemoteControl(item.remoteControlId);
          })
          .catch(() => {});
      } else {
        this.remoteControlData.splice(index, 1);
      }
    },
    //删除遥控
    deleteRemoteControl(remoteControlId) {
      let params = {
        remoteControlId: remoteControlId
      };
      PROJECTAPI.deleteRemoteControl(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.searchRemoteControlList();
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    //查询遥调列表
    searchRemoteTuningList() {
      let params = {
        projectId: this.projectId
      };
      PROJECTAPI.searchRemoteTuningList(params).then(res => {
        if (res.data.code == 200) {
          this.teleControlData = res.data.data;
          for (let i in this.teleControlData) {
            this.teleControlData[i].isConfig = true;
            if (this.teleControlData[i].dataList.length < 3) {
              for (let j = 0; j <= (3 - this.teleControlData[i].dataList.length); j++) {
                this.teleControlData[i].dataList.push({
                  title: '',
                  tuningField: ''
                })
              }
            }
          }
        }
      });
    },
    //遥调新建行
    addTeleControlRow() {
      let row = 0;
      if (this.teleControlData.length != 0) {
        row = Number(this.teleControlData[this.teleControlData.length - 1].row) + 1;
      }
      this.teleControlData.push({
        dataList: [{
          title: '',
          tuningField: ''
        }, {
          title: '',
          tuningField: ''
        }, {
          title: '',
          tuningField: ''
        }],
        isConfig: false,
        row: row
      })
    },
    //遥调删除行
    delTeleControlRow(item, index) {
      if (item.isConfig) {
        let self = this;
        this.$confirm('此行已配置数据，确定删除？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.deleteRemoteTuning(item.row, index);
          })
          .catch(() => {});
      } else {
        this.teleControlData.splice(index, 1);
      }
    },
    deleteRemoteTuning(row, index) {
      let params = {
        projectId: this.projectId,
        row: row
      };
      PROJECTAPI.deleteRemoteTuning(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("删除成功！");
          this.teleControlData.splice(index, 1);
          this.searchRemoteTuningList();
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    //遥调配置参数
    teleControlConfig(item, row, column) {
      this.teleControlConfigData = item;
      this.teleControlConfigData.projectId = this.projectId;
      this.teleControlConfigData.tuningRow = row;
      this.teleControlConfigData.tuningCell = column;
      this.$refs.teleControlDialog.open();
    },
    //遥调配置保存
    teleControlDataSave() {
      if (this.teleControlConfigData.title.length <= 20) {
        let params = this.teleControlConfigData;
        PROJECTAPI.addRemoteTuning(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("保存成功！");
            this.$refs.teleControlDialog.close();
            this.searchRemoteTuningList();
          } else {
            this.$message.warning(res.data.msg);
          }
        });
      } else {
        this.$message.warning("标题输入的字数过多，请重新输入！");
      }
    },
    cancelTeleControlDataSave() {
      this.$refs.teleControlDialog.close();
      this.isDataPointDialog = false;
    }
  }
};
</script>

<style lang="scss">
.localRemoteControlConfiguration {
  background: #fff;
  height: 70vh;

  .el-card__header {
    font-weight: bold;
    background: #f0f2f5;
    text-align: center;
  }

  .el-icon-edit,
  .el-icon-close {
    cursor: pointer;
    margin-left: 5px;
  }

  .partition {
    border: 1px solid #EBEEF5;
    height: 46%;

    .content {
      height: 25vh;
      overflow-y: auto;
    }

    .title {
      border: 1px solid #ccc;
      display: inline-block;
      padding: 10px 20px;
      margin: 10px 20px;
    }
  }

  .remoteControl {
    margin-left: 50px;
    display: flex;
    align-items: center;

    .element {
      margin-left: 20px;
      margin-bottom: 20px;
    }

    .colorBlock {
      border-radius: 4px;
      width: 70px;
      height: 35px;
    }
  }

  .newBtn {
    float: right;
    margin-top: 15px;
    margin-right: 80px;
  }

  .teleControl {
    height: calc(100% - 75px);
    margin-top: 10px;
    overflow-y: auto;

    .el-row {
      margin-left: 0px !important;
      margin-right: 0px !important;
      display: flex;
      justify-content: center;
    }

    .el-col {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    .el-form--inline .el-form-item__label {
      margin-right: -5px;
    }
  }

  .el-dialog--center .el-dialog__body {
    height: 60vh;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    overflow-y: auto;
  }

  .remoteControlDialogForm,
  .teleControlDialogForm {
    text-align: center;

    .el-form-item {
      margin-bottom: 10px;
    }

    .bottom-line {
      border-bottom: 1px solid #ccc;
    }

    .mb13 {
      margin-bottom: 13px;
    }

    .formDiv {
      margin-bottom: 5px;

      .colFlex {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .mr10 {
        margin-right: 10px;
      }
    }

    .valueDiv {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 15px;

      .element {
        margin-left: 10px;
        margin-bottom: 10px;
      }
    }

    .el-icon-close {
      margin-left: 0px;
    }
  }

  .el-icon-circle-plus-outline,
  .el-icon-remove-outline {
    cursor: pointer;
  }

  .el-icon-circle-plus-outline:before,
  .el-icon-remove-outline:before {
    font-size: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/localRemoteControlConfiguration.vue